/* eslint-disable max-len */
import React from "react";

const AccordionUpArrowIcon = () => (
  <>
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.58573 9.44425C9.97626 9.83477 10.5303 9.91392 10.8232 9.62102C11.1161 9.32813 11.0369 8.77411 10.6464 8.38359L7.81797 5.55516C7.57464 5.31183 7.26784 5.18939 7.00029 5.20251C6.73263 5.18924 6.42564 5.31169 6.18218 5.55514L3.35376 8.38357C2.96323 8.77409 2.88409 9.32811 3.17698 9.621C3.46987 9.9139 4.02389 9.83475 4.41442 9.44423L7.00007 6.85858L9.58573 9.44425Z'
        fill='black'
      />
    </svg>
  </>
);

export default AccordionUpArrowIcon;
